import React, { useEffect, useContext, useState } from "react";
import * as Const from "../../_Const";
import useJquery from "react-use-jquery";
import BlackQuote from "../../Components/BlackQuote";
import initDataTable from "../../Components/DataTable";
import Table from "../../Components/Table";
import * as MS from "../../Services/MenuService";
import * as RS from "../../Services/RenderService";
import { AppContext } from "../../Context/AppContext";
import * as OtherPagesService from "../../Services/data/OtherPagesService";

const columns = [
  // { path: "id", label: "ID" },
  { path: "title", label: "Stránka" },
  { path: "text", label: "Text", content: (item) => RS.textShortener(RS.stripHtml(item.text), 150) },
  {
    path: "imageSrc",
    label: "Obrázek",
    content: (item) => (item.imageSrc ? <img src={item.imageSrc} className="blog-index-thumb" /> : ""),
  },
  {
    path: "id",
    label: "Akce",
    content: (item) => (
      <React.Fragment>
        {RS.renderEditIcon(() => editItem(item.id))}
        {RS.renderDeleteIcon(() => deleteItem(item.id))}
      </React.Fragment>
    ),
  },
];

async function deleteItem(id) {
  try {
    await OtherPagesService.deleteData(parseInt(appContext.tenantId), parseInt(id));
    setData(await populateData(appContext.tenantId));
    RS.toastDelete();
  } catch (ex) {
    let error = "Nastala chyba při mazání dat";
    console.log(ex.response);

    if (error) {
      RS.toastError(error);
    }
  }
}

async function populateData(id) {
  let { data: item } = await OtherPagesService.getData(parseInt(id));
  return item;
}

function editItem(id) {
  MS.goToEditFormPage(Const.ID_OTHER_PAGES, id);
  //console.log(id);
}

let [appContext, setAppContext] = [2];
let [data, setData] = [2];

function PageOtherPagesIndex() {
  const $ = useJquery();
  [appContext, setAppContext] = useContext(AppContext);
  [data, setData] = useState(null);

  useEffect(() => {
    async function scopedLoadData() {
      const result = await populateData(appContext.tenantId);
      if (result) {
        setData(result);

        if ($) {
          initDataTable($);
          $("#myTable").DataTable();
        }
      }
    }
    scopedLoadData();
  }, []);

  return (
    <React.Fragment>
      <BlackQuote title="Ostatní stránky">
        V případě, že chcete <b>vytvořit samostatnou stránku na webu s vlastním odkazem</b> použijte tuto stránku
      </BlackQuote>
      {RS.renderAddButton(() => MS.goToCreatePage(Const.ID_OTHER_PAGES))}

      <div className="row">
        <div className="col-12">
          <Table columns={columns} data={data} />
        </div>
      </div>
    </React.Fragment>
  );
}

export default PageOtherPagesIndex;
